import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "components/ui/Select";
import { useGenerateTrialBalanceReport } from "http-hooks/salebill/useSalebill";
import { getDocumentUrls, getDocumentViewerRoute } from "utils/documentUrlHelper";
import useAuth from "hooks/useAuth";

const reportTypeOptions = [
  { value: "V", label: "Vendorwise" },
  { value: "C", label: "Customers" },
];

const TrailBalance = () => {
  const navigate = useNavigate();
  const { agttp } = useAuth();
  const isTrader = agttp === 1;
  const { mutateAsync: generateReport, isPending: isGenerating } =
    useGenerateTrialBalanceReport();
  const [reportType, setReportType] = useState(reportTypeOptions[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = await generateReport(
        isTrader ? {} : { reptype: reportType?.value || "V" }
      );
      const { htmlUrl, pdfUrl } = getDocumentUrls(data);
      const route = getDocumentViewerRoute("trial-balance", {
        htmlUrl,
        pdfUrl,
        documentNumber: "TB",
        documentType: "Trial Balance",
      });

      navigate(route);
    } catch (error) {
      console.error("Error generating trial balance report:", error);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">
            Trial Balance
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isTrader
              ? "Generate trial balance for all general ledger accounts."
              : "Generate ledger summary by vendor or customer."}
          </p>
        </div>
      </div>

      <div className="mt-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
            {!isTrader && (
              <div className="px-4 py-6 sm:p-8">
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                  <Select
                    label="Type"
                    options={reportTypeOptions}
                    value={reportType}
                    onChange={setReportType}
                    isClearable={false}
                  />
                </div>
              </div>
            )}

            <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
              <button
                type="submit"
                disabled={isGenerating}
                className="rounded-md bg-indigo-600 px-8 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {isGenerating ? "Generating..." : "Generate Report"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TrailBalance;
